import { useState, useEffect } from "react";

function useCanUseLocalStorage() {
  const [isLocalStorageDisabled, setIsLocalStorageDisabled] = useState(false);

  useEffect(() => {
    try {
      localStorage.setItem("__test", "test");
      localStorage.removeItem("__test");
    } catch (error) {
      setIsLocalStorageDisabled(true);
    }
  }, []);

  return isLocalStorageDisabled;
}

export default useCanUseLocalStorage;
